export const escalationMessages = {
    yesClickText: 'Ja - klik',
    noClickText: 'Nee - klik'
};
